import { CrudService, EntityProps } from '@awp/shared/CrudService';
import React from 'react';
import { isValueEmpty } from '@awp/helpers/utilsReact';
import { uniqWith } from 'lodash';
import isEqual from 'lodash/isEqual';

export default class SensorModelService extends CrudService {
  constructor(mode: string) {
    const entityName = 'Sensor Model';
    const entityPluralName = 'Sensor Models';

    super({ entityName, entityPluralName, mode });
  }

  getActionMenu(event: any): React.ReactElement {
    return <></>;
  }

  getColumns(props: any): any {
    /* Do Nothing */
  }

  getFields(props: any): React.ReactElement {
    return <></>;
  }

  getValidations(props?: any): any {
    /* Do Nothing */
  }

  mapFormToDTO(props: any): any {
    const { entity, values, observations, ...rest } = props;
    const precedences = observations?.filter((x: any) => x.ObservationTypeId !== null);

    return {
      ...entity,
      ModelNumber: values.modelnumber,
      ManufacturerId: values.manufacturerid ? values.manufacturerid.value : 0,
      TypeId: values.typeid ? values.typeid.value : 0,
      StatusTypeId: values.statustypeid ? values.statustypeid.value : 0,
      LowerLimit: !isValueEmpty(values.lowerlimit) ? values.lowerlimit : '',
      Upperlimit: !isValueEmpty(values.upperlimit) ? values.upperlimit : '',
      SensorAttributeSchema: values.sensorMetadata,
      Precedences: precedences,
    };
  }

  mapInitialValues(props: any): any {
    const { entity, getDefaultStatus, ...rest } = props;

    return {
      modelnumber: entity.ModelNumber ?? '',
      manufacturerid: entity.ManufacturerId
        ? { value: entity.ManufacturerId, label: entity.ManufacturerName }
        : { value: 0, label: '' },
      typeid: entity.TypeId ? { value: entity.TypeId, label: entity.Type } : { value: 0, label: '' },
      statustypeid: entity.StatusTypeId ? { value: entity.StatusTypeId, label: entity.Status } : getDefaultStatus(),
      lowerlimit: entity.LowerLimit ?? '',
      upperlimit: entity.UpperLimit ?? '',
      sensorMetadata: entity.SensorAttributeSchema ?? '',
      Precedences: entity.Precedences,
    };
  }

  cleanFormValues(props: EntityProps): any {
    /* Do Nothing */
  }
}
